

import React, { useState, useEffect } from "react";
import axios from "axios";
import { Form, Modal } from "react-bootstrap";
import "../App.css";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import { acceptReport, rejectReport } from "../services/reactapis";
import beauty from '../assets/beauty.jpeg';
import Motivate from '../assets/Motivate.jpg';
import Quotes from '../assets/Quotes.jpg';
import { Pagination, Scrollbar, A11y } from 'swiper/modules';
import { Swiper, SwiperSlide } from "swiper/react";
import { ApiUrl } from '../Constants/Weburl';
import CustomTable from "../components/CustomTable";
import CustomButton from "../components/CustomButton";
import CustomSwitch from "../components/Customswitch";
import CustomPagination from '../components/Custompagination'
import CustomContainer from "../components/Customsettingscontain";
import CustomInput from '../components/Custominput';
import CustomCard from '../components/CustomCard';
import "swiper/css";
import { useSearchParams } from "react-router-dom";
import { rejectWithdrawal, fetchRejectedWithdrawals } from "../services/reactapis";
import Layout from "../components/Layout";
import useExpandableRows from "../components/useExpandableRows";
import useHiddenColumns from "../components/useHiddenFields";


export default function Withdrawal() {
    const [activeTab, setActiveTab] = useState("posts");
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [entries, setEntries] = useState(10);
    const [type, setType] = useState("post");
    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState([]);
    const [viewPost, setViewPost] = useState(null);
    const [isViewModalOpen, setIsViewModalOpen] = useState(false);
    const adminToken = localStorage.getItem("adminToken");
    const [withdrawals, setWithdrawals] = useState([]);
    const [actionLoadingId, setActionLoadingId] = useState(null);
    const [searchParams] = useSearchParams();

    //complete 
    const [completedWithdrawals, setCompletedWithdrawals] = useState([]);
    const [rejectedWithdrawals, setRejectedWithdrawals] = useState([]);

    const { toggleExpand, isExpanded } = useExpandableRows();

    // useEffect(() => {
    //     const searchParam = searchParams.get("search");
    //     if (searchParam) {
    //         setSearch(searchParam);
    //     }
    // }, []);


    useEffect(() => {
        const searchParam = searchParams.get("search");
        const tabParam = searchParams.get("tab");

        console.log("URL SEARCH:", searchParam);
        console.log("URL TAB:", tabParam);

        if (searchParam) {
            setSearch(searchParam);
            setCurrentPage(1);
        }

        if (tabParam === "pending") {
            setActiveTab("posts");
            setType("post");
        } else if (tabParam === "completed") {
            setActiveTab("users");
            setType("user");
        } else if (tabParam === "rejected") {
            setActiveTab("rejects");
            setType("rejects");
        }
    }, [searchParams]);

    useEffect(() => {
        if (activeTab === "users") {
            fetchCompleted();
        }

        if (activeTab === "rejects") {
            getRejectedWithdrawals();
        }
    }, [activeTab]);

    const headers = [
        {
            label: "Request Number",
            className: "col-hide-req",
            field: "hide-req"

        },
        {
            label: "User",
            className: "col-hide-user",
            field: "hide-user"

        },
        {
            label: "Coin Details",
            className: "col-hide-4",
            field: "hide-4"
        },
        {
            label: "Payment Details",
            //  className: 'Postreport' 
            className: "col-hide-3",
             field: "hide-3"
        },
        {
            label: "Created Date",
            className: "col-hide-2",
             field: "hide-2"
            //  className: 'Postdate'
        },
        {
            label: "Action",
            className: "col-hide-1",
             field: "hide-1"
            // className: 'Postdate' 
        },
    ]

    const hiddenFields = useHiddenColumns(".rr1-table", headers);


    const getImageUrl = (img) => {
        if (!img) return "";
        if (img.startsWith("http")) return img;
        return `${ApiUrl}${img.replace("\\", "/")}`;
    };

    const currentWithdrawals =
        activeTab === "users"
            ? completedWithdrawals
            // : withdrawals;
            : activeTab === "rejects"
                ? rejectedWithdrawals
                : withdrawals;

    // const filteredWithdrawals = currentWithdrawals.filter((w) => {
    //     if (!search) return true;
    //     const username = w.user?.username || "";
    //     const name = w.user?.name || "";
    //     return (
    //         username.toLowerCase().includes(search.toLowerCase()) ||
    //         name.toLowerCase().includes(search.toLowerCase())
    //     );
    // });

    const filteredWithdrawals = currentWithdrawals.filter((w) => {
        if (!search) return true;

        const term = search.toLowerCase().trim();

        const username =
            w?.transaction?.user?.username?.toLowerCase() || "";

        const name =
            w?.transaction?.user?.name?.toLowerCase() || "";

        const requestNumber =
            String(w?.request_number || "").toLowerCase();

        return (
            username.includes(term) ||
            name.includes(term) ||
            requestNumber.includes(term)
        );
    });

    const indexOfLast = currentPage * entries;
    const indexOfFirst = indexOfLast - entries;
    const displayedWithdrawals = filteredWithdrawals.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredWithdrawals.length / entries);

    useEffect(() => {
        fetchPending();
    }, []);

    const fetchPending = async () => {
        try {
            const token = localStorage.getItem("adminToken");
            const res = await axios.get(
                `${ApiUrl}api/pendinglist/withdraw`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log('res fetchpending', res.data.data)
            setWithdrawals(res.data.data);
        } catch (err) {
            console.error("Pending fetch error:", err);
            alert("Failed to load pending withdrawals");
        } finally {
            setLoading(false);
        }
    };

    //approve
    const handleApprove = async (requestId) => {
        if (!window.confirm("Approve this withdrawal and send PayPal payout?")) return;

        setActionLoadingId(requestId);
        try {
            const token = localStorage.getItem("adminToken");
            const res = await axios.post(
                `${ApiUrl}api/acceptlist/withdraw`,
                { requestId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            console.log("res handleapprove", res.data);

            if (res.data.success) {
                alert("Payout sent successfully!");
                // setWithdrawals((prev) =>
                //     prev.map((w) =>
                //         w.id === requestId ? { ...w, status: "approved" } : w
                //     )
                // );

                setWithdrawals((prev) =>
                    prev.filter((w) => w.id !== requestId)
                );

                fetchCompleted();
            } else {
                alert(res.data.message || "Approve failed");
            }
        } catch (err) {
            console.error("Approve error:", err?.response?.data || err);
            alert(err?.response?.data?.message || "Failed to approve withdrawal");
        } finally {
            setActionLoadingId(null);
        }
    };

    const checkPayoutStatus = async (requestId) => {
        try {
            const token = localStorage.getItem("adminToken");

            const res = await axios.get(
                `${ApiUrl}api/withdrawal/${requestId}/payout-status`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("PAYOUT STATUS RESPONSE:", res.data);

            if (res.data.success) {
                const paypalStatus = res.data.status;

                alert(`PayPal Status: ${paypalStatus}`);

                // Update frontend immediately
                setWithdrawals((prev) =>
                    prev.map((item) =>
                        item.id === requestId
                            ? {
                                ...item,
                                status:
                                    paypalStatus === "SUCCESS"
                                        ? "paid"
                                        : paypalStatus === "DENIED" ||
                                            paypalStatus === "CANCELED"
                                            ? "rejected"
                                            : item.status,
                            }
                            : item
                    )
                );
            }
        } catch (error) {
            console.log(
                "CHECK PAYOUT STATUS ERROR:",
                error?.response?.data || error
            );

            alert(
                error?.response?.data?.message ||
                "Failed to check payout status"
            );
        }
    };

    const fetchCompleted = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken");

            const res = await axios.get(
                `${ApiUrl}api/completedlist/withdraw`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            console.log("COMPLETED WITHDRAWALS:", res.data);

            setCompletedWithdrawals(res.data.data || []);

        } catch (error) {
            console.log(
                "Completed fetch error:",
                error?.response?.data || error
            );

            alert("Failed to load completed withdrawals");

        } finally {
            setLoading(false);
        }
    };


    const handleRejectWithdrawal = async (requestId) => {
        try {
            const token = localStorage.getItem("adminToken");

            const response = await rejectWithdrawal(token, requestId);

            if (response?.success) {
                console.log("REJECT SUCCESS:", response);

                // pending list refresh
                fetchPending();
            }

        } catch (error) {
            console.log(
                "REJECT ERROR:",
                error?.response?.data || error.message
            );
        }
    };


    const getRejectedWithdrawals = async () => {
        try {
            setLoading(true);

            const token = localStorage.getItem("adminToken");

            const response = await fetchRejectedWithdrawals(token);

            if (response?.success) {
                setRejectedWithdrawals(response.data || []);
            } else {
                setRejectedWithdrawals([]);
            }

        } catch (error) {
            console.log(
                "GET REJECTED WITHDRAWALS ERROR:",
                error?.response?.data || error.message
            );

            setRejectedWithdrawals([]);

            alert(
                error?.response?.data?.message ||
                "Failed to load rejected withdrawals"
            );
        } finally {
            setLoading(false);
        }
    };




   

    return (
        // <div className="layout">

        <Layout>
            <CustomContainer
                // className="reports-container"
                // className="rr-wrapperhashtag" 
                className="rr-wrapperhashtag wd-withdrawal-wrapper"
                fluid="false">
                {/* <div className="topbar">
                        <h3>Withdrawals</h3>
                        {search && (
                            <span style={{ marginLeft: '15px', fontSize: '14px', color: '#666' }}>
                                Showing results for: <strong>"{search}"</strong>
                            </span>
                        )}
                    </div> */}

                <CustomCard
                    // className="reports-card"
                    className="rr-card"
                >
                    <div
                        // className="tabs"
                        className="tabs wds-tabs-row"
                    >
                        <div className="activetab">
                            <CustomButton
                                className={activeTab === "posts" ? "tab active" : "tab"}
                                onClick={() => { setActiveTab("posts"); setType("post"); }}
                            >
                                Pending
                            </CustomButton>
                            <CustomButton
                                className={activeTab === "users" ? "tab active" : "tab"}
                                onClick={() => { setActiveTab("users"); setType("user"); setCurrentPage(1); fetchCompleted(); }}
                            >
                                Completed
                            </CustomButton>
                            <CustomButton
                                className={activeTab === "rejects" ? "tab active" : "tab"}
                                onClick={() => {
                                    setActiveTab("rejects"); setType("rejects"); setCurrentPage(1);
                                    getRejectedWithdrawals();
                                }}
                            >
                                Rejected
                            </CustomButton>
                        </div>

                        <div
                            // className="rr-controls"
                            className="wds-controls"
                        >
                            <div
                                // className="show-entries"
                                className="rr-left"
                            >
                                <span>Show</span>
                                <Form.Select
                                    className="rr-select"
                                    value={entries}
                                    onChange={(e) => setEntries(Number(e.target.value))}
                                >
                                    <option value={5}>5</option>
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                </Form.Select>
                                <span>entries</span>
                            </div>

                            <div
                                // className="search-box"
                                className="rr-right"
                            >
                                <span>Search: </span>
                                <CustomInput
                                    className="rr-search"
                                    type="text"
                                    value={search}
                                    onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
                                    placeholder=""
                                />
                            </div>
                        </div>
                    </div>

                    <CustomTable headers={headers} className="rr1-table table">
                        {loading && (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>Loading...</td>
                            </tr>
                        )}

                        {!loading && displayedWithdrawals.length === 0 && (
                            <tr>
                                <td colSpan="6" style={{ textAlign: "center", padding: 20 }}>
                                    {search ? `No results found for "${search}"` : "No data found"}
                                </td>
                            </tr>
                        )}

                        {!loading &&
                            displayedWithdrawals.map((r, idx) => (
                                <React.Fragment key={r.id ?? idx}>
                                    <tr className="rr-actionshastag" >
                                        <td  className="col-hide-req" style={{ padding: "18px 20px", width: '20%' , display:'flex' , alignItems:'center'}}>
                                            {hiddenFields.length > 0 && (
                                                <button
                                                    type="button"
                                                    className={`row-expand-toggle ${isExpanded(r.id) ? "is-open" : ""
                                                        }`}
                                                    onClick={() => toggleExpand(r.id)}
                                                    aria-label="Show more details"
                                                >
                                                    {isExpanded(r.id) ? "−" : "+"}
                                                </button>
                                            )}
                                            <span style={{ color: "#8b5cf6", fontWeight: 600, fontSize: 16 }}>
                                                {r.request_number}
                                            </span>
                                        </td>
                                        <td className="Postusertable col-hide-user">
                                            <div className="chip">
                                                <img src={getImageUrl(r.transaction?.user?.avatar)} alt="" style={{ width: 40, height: 40, borderRadius: "50%" }} />
                                                <div>
                                                    <div style={{ fontWeight: 600, fontSize: 14, color: "#111" }}>{r.transaction.user?.username}</div>
                                                    <div style={{ fontSize: 13, color: "#6b7280", textAlign: 'left' }}>{r.transaction.user?.name}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="col-hide-4" style={{ padding: "18px 20px" }}>
                                            <div style={{ color: "#a855f7", fontSize: 18, fontWeight: 700 }}>
                                                {/* {r.transaction.amount} */}
                                                {`${r.transaction.currencySymbol}${Math.abs(r.transaction.amount).toFixed(4)}`}
                                            </div>
                                            <div style={{ fontSize: 13, color: "#111111" }}>Coins: {r.transaction.coins}</div>
                                            <div style={{ fontSize: 12, color: "#9ca3af" }}>Coin Value: ${Number(r.transaction.coinValue || 0).toFixed(2)}</div>
                                        </td>
                                        <td style={{ padding: "18px 20px" }} className="col-hide-3">
                                            <div style={{ color: "#38bdf8", fontWeight: 600, fontSize: 14 }}>{r?.transaction?.withdraw_gateway?.title}</div>
                                            <div style={{ fontSize: 13, color: "#374151", marginTop: 4 }}>{r.account_details}</div>
                                        </td>
                                        <td className="col-hide-2" style={{ padding: "18px 20px", fontSize: 14, color: "#374151" }}>
                                            {new Date(r.createdAt).toLocaleDateString("en-IN")}
                                        </td>
                                        <td className="col-hide-1" style={{ padding: "18px 20px" }}>
                                            {/* {r.status === "pending" && (
                                                <div style={{ display: "flex", gap: 10 }}>
                                                    <CustomButton style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #22c55e", background: "#ecfdf5", color: "#16a34a", cursor: "pointer", fontWeight: 700, padding: 0 }}>✓</CustomButton>
                                                    <CustomButton style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #ef4444", background: "#fef2f2", color: "#dc2626", cursor: "pointer", fontWeight: 700, padding: 0 }}>✕</CustomButton>
                                                </div>
                                            )} */}
                                            {r.transaction.status === "pending" && (
                                                <div style={{ display: "flex", gap: 10 }}>
                                                    <CustomButton
                                                        disabled={actionLoadingId === r?.transaction?.id}
                                                        onClick={() => handleApprove(r?.id)}
                                                        style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #22c55e", background: "#ecfdf5", color: "#16a34a", cursor: "pointer", fontWeight: 700, padding: 0, opacity: actionLoadingId === r.transaction.id ? 0.5 : 1 }}
                                                    >
                                                        {actionLoadingId === r?.transaction?.id ? "…" : "✓"}
                                                    </CustomButton>
                                                    <CustomButton
                                                        disabled={actionLoadingId === r?.id}
                                                        // onClick={() => handleReject(r.id)}
                                                        onClick={() => handleRejectWithdrawal(r?.id)}
                                                        style={{ width: 34, height: 34, borderRadius: 8, border: "1px solid #ef4444", background: "#fef2f2", color: "#dc2626", cursor: "pointer", fontWeight: 700, padding: 0, opacity: actionLoadingId === r?.id ? 0.5 : 1 }}
                                                    >
                                                        {actionLoadingId === r?.id ? "…" : "✕"}
                                                    </CustomButton>
                                                </div>
                                            )}
                                            {r.transaction.status === "approved" && (
                                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                    <span style={{ color: "#16a34a", fontWeight: 600 }}>Paid</span>
                                                    <CustomButton
                                                        onClick={() => checkPayoutStatus(r.id)}
                                                        style={{ fontSize: 12, padding: "4px 8px", border: "1px solid #38bdf8", background: "#f0f9ff", color: "#0369a1", borderRadius: 6, cursor: "pointer" }}
                                                    >
                                                        Check Status
                                                    </CustomButton>
                                                </div>
                                            )}
                                            {r.transaction.status === "paid" && (
                                                <span
                                                    style={{
                                                        color: "#16a34a",
                                                        fontWeight: 600
                                                    }}
                                                >
                                                    Credited
                                                </span>
                                            )}
                                            {r?.transaction.status === "rejected" && <span style={{ color: "#dc2626", fontWeight: 600 }}>Rejected</span>}
                                        </td>
                                    </tr>

                                    {isExpanded(r.id) && hiddenFields.length > 0 && (
                                        <tr className="row-expand-details">
                                            <td colSpan={6}>
                                                <div className="expand-details">

                                                    {hiddenFields.map(({ field, label }) => (
                                                        <div className="expand-item" key={field}>

                                                            <span className="expand-label">
                                                                {label}
                                                            </span>

                                                            {/* Request Number */}
                                                            {field === "hide-req" && (
                                                                <span className="expand-value">
                                                                    {r.request_number}
                                                                </span>
                                                            )}

                                                            {/* User */}
                                                            {field === "hide-user" && (
                                                                <div className="expand-value">
                                                                    <div className="chip">
                                                                        <img
                                                                            src={getImageUrl(
                                                                                r.transaction?.user?.avatar
                                                                            )}
                                                                            alt=""
                                                                            style={{
                                                                                width: 40,
                                                                                height: 40,
                                                                                borderRadius: "50%"
                                                                            }}
                                                                        />

                                                                        <div>
                                                                            <div
                                                                                style={{
                                                                                    fontWeight: 600,
                                                                                    fontSize: 14,
                                                                                    color: "#111"
                                                                                }}
                                                                            >
                                                                                {r.transaction?.user?.username}
                                                                            </div>

                                                                            <div
                                                                                style={{
                                                                                    fontSize: 13,
                                                                                    color: "#6b7280"
                                                                                }}
                                                                            >
                                                                                {r.transaction?.user?.name}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {/* Coin Details */}
                                                            {field === "hide-4" && (
                                                                <div className="expand-value">

                                                                    <div
                                                                        style={{
                                                                            color: "#a855f7",
                                                                            fontSize: 18,
                                                                            fontWeight: 700
                                                                        }}
                                                                    >
                                                                        {`${r.transaction?.currencySymbol}${Math.abs(
                                                                            r.transaction?.amount || 0
                                                                        ).toFixed(4)}`}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: 13,
                                                                            color: "#111111"
                                                                        }}
                                                                    >
                                                                        Coins: {r.transaction?.coins}
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: 12,
                                                                            color: "#9ca3af"
                                                                        }}
                                                                    >
                                                                        Coin Value: $
                                                                        {Number(
                                                                            r.transaction?.coinValue || 0
                                                                        ).toFixed(2)}
                                                                    </div>

                                                                </div>
                                                            )}

                                                            {/* Payment Details */}
                                                            {field === "hide-3" && (
                                                                <div className="expand-value">

                                                                    <div
                                                                        style={{
                                                                            color: "#38bdf8",
                                                                            fontWeight: 600,
                                                                            fontSize: 14
                                                                        }}
                                                                    >
                                                                        {
                                                                            r?.transaction
                                                                                ?.withdraw_gateway?.title
                                                                        }
                                                                    </div>

                                                                    <div
                                                                        style={{
                                                                            fontSize: 13,
                                                                            color: "#374151",
                                                                            marginTop: 4
                                                                        }}
                                                                    >
                                                                        {r.account_details}
                                                                    </div>

                                                                </div>
                                                            )}

                                                            {/* Created Date */}
                                                            {field === "hide-2" && (
                                                                <span className="expand-value">
                                                                    {new Date(
                                                                        r.createdAt
                                                                    ).toLocaleDateString("en-IN")}
                                                                </span>
                                                            )}

                                                            {/* Action */}
                                                            {field === "hide-1" && (
                                                                <div
                                                                    style={{
                                                                        display: "flex",
                                                                        gap: 8
                                                                    }}
                                                                >
                                                                    {r.transaction?.status === "pending" && (
                                                                        <>
                                                                            <CustomButton
                                                                                disabled={
                                                                                    actionLoadingId === r.id
                                                                                }
                                                                                onClick={() =>
                                                                                    handleApprove(r.id)
                                                                                }
                                                                                style={{
                                                                                    width: 34,
                                                                                    height: 34,
                                                                                    borderRadius: 8,
                                                                                    border:
                                                                                        "1px solid #22c55e",
                                                                                    background:
                                                                                        "#ecfdf5",
                                                                                    color: "#16a34a",
                                                                                    cursor: "pointer",
                                                                                    fontWeight: 700,
                                                                                    padding: 0
                                                                                }}
                                                                            >
                                                                                {actionLoadingId === r.id
                                                                                    ? "…"
                                                                                    : "✓"}
                                                                            </CustomButton>

                                                                            <CustomButton
                                                                                disabled={
                                                                                    actionLoadingId === r.id
                                                                                }
                                                                                onClick={() =>
                                                                                    handleRejectWithdrawal(
                                                                                        r.id
                                                                                    )
                                                                                }
                                                                                style={{
                                                                                    width: 34,
                                                                                    height: 34,
                                                                                    borderRadius: 8,
                                                                                    border:
                                                                                        "1px solid #ef4444",
                                                                                    background:
                                                                                        "#fef2f2",
                                                                                    color: "#dc2626",
                                                                                    cursor: "pointer",
                                                                                    fontWeight: 700,
                                                                                    padding: 0
                                                                                }}
                                                                            >
                                                                                {actionLoadingId === r.id
                                                                                    ? "…"
                                                                                    : "✕"}
                                                                            </CustomButton>
                                                                        </>
                                                                    )}

                                                                    {r.transaction?.status === "approved" && (
                                                                        <div
                                                                            style={{
                                                                                display: "flex",
                                                                                alignItems: "center",
                                                                                gap: 8
                                                                            }}
                                                                        >
                                                                            <span
                                                                                style={{
                                                                                    color: "#16a34a",
                                                                                    fontWeight: 600
                                                                                }}
                                                                            >
                                                                                Paid
                                                                            </span>

                                                                            <CustomButton
                                                                                onClick={() =>
                                                                                    checkPayoutStatus(r.id)
                                                                                }
                                                                                style={{
                                                                                    fontSize: 12,
                                                                                    padding: "4px 8px",
                                                                                    border:
                                                                                        "1px solid #38bdf8",
                                                                                    background:
                                                                                        "#f0f9ff",
                                                                                    color: "#0369a1",
                                                                                    borderRadius: 6,
                                                                                    cursor: "pointer"
                                                                                }}
                                                                            >
                                                                                Check Status
                                                                            </CustomButton>
                                                                        </div>
                                                                    )}

                                                                    {r.transaction?.status === "paid" && (
                                                                        <span
                                                                            style={{
                                                                                color: "#16a34a",
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            Credited
                                                                        </span>
                                                                    )}

                                                                    {r.transaction?.status === "rejected" && (
                                                                        <span
                                                                            style={{
                                                                                color: "#dc2626",
                                                                                fontWeight: 600
                                                                            }}
                                                                        >
                                                                            Rejected
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            )}

                                                        </div>
                                                    ))}

                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                    </CustomTable>

                    <div className="rr-footer">
                        <span>
                            Showing {filteredWithdrawals.length === 0 ? 0 : indexOfFirst + 1} to{" "}
                            {Math.min(indexOfLast, filteredWithdrawals.length)} of{" "}
                            {filteredWithdrawals.length} entries
                        </span>
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page) => setCurrentPage(page)}
                            className="rr-pagination"
                            pageClassName="rr-page"
                            activeClassName="active"
                            ellipsisClassName="rr-page"
                        />
                    </div>

                    {/* Modal same as before - touch pண்ணல */}
                </CustomCard>
            </CustomContainer>
        </Layout>
        // </div>
    );
}